var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"table-pagination"},[_c('el-pagination',{attrs:{"current-page":_vm.pagination.pageIndex,"page-sizes":[10, 20, 30, 40],"page-size":_vm.pagination.pageSize,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.pagination.total,"background":""},on:{"size-change":_vm.sizeChange,"current-change":_vm.currentChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }